<form *ngIf="contactForm" nz-form [formGroup]="contactForm">
  <h3 *ngIf="editingType === 'caretaker'" class="contact-section-title">
    {{ 'CONTACTS.CARETAKER_SERVICE_INFORMATION' | translate }}
  </h3>
  <nz-form-item>
    <nz-form-label [nzSpan]="6" nzFor="name">{{ 'CONTACTS.NAME' | translate }}<span class="required-asterisk-after">*</span></nz-form-label>
    <nz-form-control [nzSpan]="14" [nzValidateStatus]="contactForm.get('name')!" [nzErrorTip]="nameErrTpl">
      <input nz-input formControlName="name" />
      <ng-template #nameErrTpl let-control>
        <ng-container *ngIf="control.hasError('required')">
          {{ 'FORM_ERRORS.NAME_REQUIRED' | translate }}
        </ng-container>
      </ng-template>
    </nz-form-control>
  </nz-form-item>

  <ng-container *ngIf="(editingType === 'employee' && showEmailFieldModal) || editingType === 'caretaker' || editingType === 'service'">
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="email">{{ 'CONTACTS.EMAIL' | translate }}<span class="required-asterisk-after" *ngIf="editingType === 'employee' && showEmailFieldModal">*</span></nz-form-label>
      <nz-form-control [nzSpan]="14" [nzValidateStatus]="contactForm.get('email')!" [nzErrorTip]="emailErrTpl">
        <input nz-input formControlName="email" />
        <ng-template #emailErrTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            {{ 'FORM_ERRORS.EMAIL_REQUIRED' | translate }}
          </ng-container>
          <ng-container *ngIf="control.hasError('email')">
            {{ 'FORM_ERRORS.EMAIL_INVALID' | translate }}
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
  </ng-container>

  <ng-container *ngIf="(editingType === 'employee' && showPhoneFieldModal) || editingType === 'caretaker' || editingType === 'service'">
    <div class="phone-mobile-requirement" *ngIf="shouldRequirePhoneOrMobile()">
      <div class="phone-mobile-requirement-title">
        {{ 'CONTACTS.PHONE_MOBILE_GROUP_LABEL' | translate }}
        <span class="required-asterisk-after">*</span>
      </div>
      <div class="phone-mobile-requirement-helper">
        {{ 'CONTACTS.PHONE_OR_MOBILE_HELPER' | translate }}
      </div>
    </div>

    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="phone">{{ 'CONTACTS.PHONE' | translate }}</nz-form-label>
      <nz-form-control [nzSpan]="14" [nzValidateStatus]="contactForm.get('phone')!" [nzErrorTip]="phoneErrTpl">
        <input nz-input formControlName="phone" />
        <ng-template #phoneErrTpl let-control>
          <ng-container *ngIf="control.hasError('invalidPhone')">
            {{ 'FORM_ERRORS.INVALID_PHONE' | translate }}
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
  </ng-container>

  <ng-container *ngIf="editingType === 'employee' && showPhoneFieldModal">
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="mobile">
        {{ 'CONTACTS.MOBILE_OPTIONAL' | translate }}
      </nz-form-label>
      <nz-form-control [nzSpan]="14" [nzValidateStatus]="contactForm.get('mobile')!" [nzErrorTip]="mobileErrTpl">
        <input nz-input formControlName="mobile" />
        <ng-template #mobileErrTpl let-control>
          <ng-container *ngIf="control.hasError('invalidPhone')">
            {{ 'FORM_ERRORS.INVALID_PHONE' | translate }}
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
  </ng-container>

  <ng-container *ngIf="editingType === 'service' || editingType === 'caretaker'">
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="mobile">
        {{ editingType === 'caretaker' ? ('CONTACTS.MOBILE_OPTIONAL' | translate) : ('CONTACTS.MOBILE' | translate) }}
      </nz-form-label>
      <nz-form-control [nzSpan]="14" [nzValidateStatus]="contactForm.get('mobile')!" [nzErrorTip]="mobileErrTpl2">
        <input nz-input formControlName="mobile" />
        <ng-template #mobileErrTpl2 let-control>
          <ng-container *ngIf="control.hasError('invalidPhone')">
            {{ 'FORM_ERRORS.INVALID_PHONE' | translate }}
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
  </ng-container>

  <div
    class="phone-mobile-group-error"
    *ngIf="
      shouldRequirePhoneOrMobile()
      && contactForm.hasError('phoneOrMobileRequired')
      && (contactForm.get('phone')?.touched || contactForm.get('mobile')?.touched || contactForm.touched)
    "
  >
    {{ 'FORM_ERRORS.PHONE_OR_MOBILE_REQUIRED' | translate }}
  </div>

  <ng-container *ngIf="editingType === 'caretaker'">
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="emergencyNumber">
        {{ 'CONTACTS.EMERGENCY_NUMBER' | translate }}
      </nz-form-label>
      <nz-form-control [nzSpan]="14" [nzValidateStatus]="contactForm.get('emergencyNumber')!" [nzErrorTip]="caretakerEmergencyNumErrTpl">
        <input nz-input formControlName="emergencyNumber" />
        <ng-template #caretakerEmergencyNumErrTpl let-control>
          <ng-container *ngIf="control.hasError('invalidPhone')">
            {{ 'FORM_ERRORS.INVALID_PHONE' | translate }}
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
  </ng-container>

  <ng-container *ngIf="editingType === 'caretaker'">
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="note">
        {{ 'CONTACTS.CARETAKER_NOTE' | translate }}
      </nz-form-label>
      <nz-form-control [nzSpan]="14" [nzValidateStatus]="contactForm.get('note')!" [nzErrorTip]="caretakerNoteErrTpl">
        <input
          nz-input
          formControlName="note"
          [attr.placeholder]="'CONTACTS.CARETAKER_NOTE_PLACEHOLDER' | translate"
          maxlength="80"
        />
        <ng-template #caretakerNoteErrTpl let-control>
          <ng-container *ngIf="control.hasError('maxlength')">
            {{ 'FORM_ERRORS.CARETAKER_NOTE_TOO_LONG' | translate }}
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
  </ng-container>

  <ng-container *ngIf="editingType === 'service'">
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="emergencyNumber">
        {{ 'CONTACTS.EMERGENCY_NUMBER' | translate }}
      </nz-form-label>
      <nz-form-control [nzSpan]="14" [nzValidateStatus]="contactForm.get('emergencyNumber')!" [nzErrorTip]="serviceEmergencyNumErrTpl">
        <input nz-input formControlName="emergencyNumber" />
        <ng-template #serviceEmergencyNumErrTpl let-control>
          <ng-container *ngIf="control.hasError('invalidPhone')">
            {{ 'FORM_ERRORS.INVALID_PHONE' | translate }}
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
  </ng-container>

  <ng-container *ngIf="editingType === 'service'">
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="serviceNote">
        {{ 'CONTACTS.SERVICE_NOTE' | translate }}
      </nz-form-label>
      <nz-form-control [nzSpan]="14" [nzValidateStatus]="contactForm.get('serviceNote')!" [nzErrorTip]="serviceNoteErrTpl">
        <input
          nz-input
          formControlName="serviceNote"
          [attr.placeholder]="'CONTACTS.SERVICE_NOTE_PLACEHOLDER' | translate"
          maxlength="80"
        />
        <ng-template #serviceNoteErrTpl let-control>
          <ng-container *ngIf="control.hasError('maxlength')">
            {{ 'FORM_ERRORS.SERVICE_NOTE_TOO_LONG' | translate }}
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
  </ng-container>

  <ng-container *ngIf="editingType === 'caretaker'">
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="address">
        <span>{{ 'CONTACTS.ADDRESS' | translate }}</span>
        <span
          nz-icon
          nzType="info-circle"
          nz-popover
          [nzPopoverTitle]="'COMMON.ADDRESS_FORMAT_HELP_TITLE' | translate"
          [nzPopoverContent]="addressFormatPopover"
          nzPopoverPlacement="rightTop"
          nzPopoverOverlayClassName="address-format-popover"
          style="margin-left: 6px; cursor: pointer;"
        ></span>
      </nz-form-label>
      <nz-form-control [nzSpan]="14" [nzValidateStatus]="contactForm.get('address')!" [nzErrorTip]="caretakerAddressErrTpl">
        <input nz-input formControlName="address" />
        <ng-template #caretakerAddressErrTpl let-control>
          <ng-container *ngIf="control.hasError('invalidAddress')">
            {{ 'FORM_ERRORS.ADDRESS_ERROR' | translate }}
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
  </ng-container>

  <ng-container *ngIf="editingType === 'caretaker'">
    <nz-form-item *ngFor="let day of weekDays">
      <nz-form-label [nzSpan]="8">{{ 'COMPANY_PAGE.AVAILABILITY_' + (day | uppercase) | translate }}</nz-form-label>
      <nz-form-control [nzSpan]="16">
        <nz-time-picker
          formControlName="{{ day + 'StartTime' }}"
          nzFormat="HH:mm"
          (ngModelChange)="onStartTimeChange(day)"
        >
        </nz-time-picker>
        <span style="margin: 0 8px;">{{ 'COMPANY_PAGE.TO' | translate }}</span>
        <nz-time-picker
          formControlName="{{ day + 'EndTime' }}"
          nzFormat="HH:mm"
          [nzDisabledHours]="getDisabledEndHours(day)"
          [nzDisabledMinutes]="getDisabledEndMinutes(day)"
          [nzDisabledSeconds]="getDisabledEndSeconds(day)"
          (ngModelChange)="onEndTimeChange(day)"
        >
        </nz-time-picker>
      </nz-form-control>
    </nz-form-item>
  </ng-container>

  <ng-container *ngIf="editingType === 'caretaker'">
    <section class="contact-persons-section" formArrayName="contactPersons">
      <div class="contact-persons-section__header">
        <div class="contact-persons-section__heading">
          <h3 class="contact-section-title">{{ 'CONTACTS.CONTACT_PERSONS' | translate }}</h3>
          <p class="contact-persons-section__hint">{{ 'CONTACTS.CONTACT_PERSONS_PUBLIC_HINT' | translate }}</p>
          <p class="contact-persons-section__count">
            {{ contactPersonCountKey() | translate:{ count: contactPersons.length } }}
          </p>
        </div>
        <button class="contact-persons-section__add" nz-button nzType="default" type="button" (click)="addContactPerson()">
          <span nz-icon nzType="plus"></span>
          {{ 'CONTACTS.ADD_CONTACT_PERSON' | translate }}
        </button>
      </div>

      <div *ngIf="!contactPersons.length" class="contact-persons-empty">
        {{ 'CONTACTS.NO_CONTACT_PERSONS' | translate }}
      </div>

      <article
        *ngFor="let person of contactPersons.controls; let index = index"
        class="contact-person-card"
        [formGroupName]="index"
      >
        <div class="contact-person-card__header">
          <strong class="contact-person-card__title">{{ 'CONTACTS.CONTACT_PERSON' | translate }} {{ index + 1 }}</strong>
          <div class="contact-person-card__actions">
            <label class="contact-person-primary">
              <input
                type="radio"
                name="primary-contact-person"
                [checked]="person.get('isPrimary')?.value === true"
                (change)="setPrimaryContactPerson(index)"
              />
              {{ 'CONTACTS.PRIMARY_CONTACT_PERSON' | translate }}
            </label>
            <button
              nz-button
              nzType="text"
              nzDanger
              type="button"
              (click)="removeContactPerson(index)"
              [attr.aria-label]="'CONTACTS.REMOVE_CONTACT_PERSON' | translate"
            >
              <span nz-icon nzType="delete"></span>
              {{ 'CONTACTS.REMOVE_CONTACT_PERSON' | translate }}
            </button>
          </div>
        </div>

        <div class="contact-person-card__grid">
          <nz-form-item class="contact-person-field">
            <nz-form-label [nzSpan]="24">{{ 'CONTACTS.CONTACT_PERSON_NAME' | translate }}<span class="required-asterisk-after">*</span></nz-form-label>
            <nz-form-control [nzSpan]="24" [nzValidateStatus]="person.get('name')!" [nzErrorTip]="contactPersonNameErrTpl">
              <input nz-input formControlName="name" maxlength="120" />
              <ng-template #contactPersonNameErrTpl let-control>
                <ng-container *ngIf="control.hasError('required')">
                  {{ 'CONTACTS.CONTACT_PERSON_NAME_REQUIRED' | translate }}
                </ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item class="contact-person-field">
            <nz-form-label [nzSpan]="24">{{ 'CONTACTS.CONTACT_PERSON_POSITION' | translate }}</nz-form-label>
            <nz-form-control [nzSpan]="24" [nzValidateStatus]="person.get('position')!">
              <input nz-input formControlName="position" maxlength="120" />
            </nz-form-control>
          </nz-form-item>
          <nz-form-item class="contact-person-field">
            <nz-form-label [nzSpan]="24">{{ 'CONTACTS.PHONE' | translate }}</nz-form-label>
            <nz-form-control [nzSpan]="24" [nzValidateStatus]="person.get('phone')!" [nzErrorTip]="contactPersonPhoneErrTpl">
              <input nz-input formControlName="phone" maxlength="64" />
              <ng-template #contactPersonPhoneErrTpl let-control>
                <ng-container *ngIf="control.hasError('invalidPhone')">{{ 'FORM_ERRORS.INVALID_PHONE' | translate }}</ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item class="contact-person-field">
            <nz-form-label [nzSpan]="24">{{ 'CONTACTS.MOBILE_OPTIONAL' | translate }}</nz-form-label>
            <nz-form-control [nzSpan]="24" [nzValidateStatus]="person.get('mobile')!" [nzErrorTip]="contactPersonMobileErrTpl">
              <input nz-input formControlName="mobile" maxlength="64" />
              <ng-template #contactPersonMobileErrTpl let-control>
                <ng-container *ngIf="control.hasError('invalidPhone')">{{ 'FORM_ERRORS.INVALID_PHONE' | translate }}</ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
          <nz-form-item class="contact-person-field contact-person-field--email">
            <nz-form-label [nzSpan]="24">{{ 'CONTACTS.EMAIL' | translate }}</nz-form-label>
            <nz-form-control [nzSpan]="24" [nzValidateStatus]="person.get('email')!" [nzErrorTip]="contactPersonEmailErrTpl">
              <input nz-input formControlName="email" maxlength="254" />
              <ng-template #contactPersonEmailErrTpl let-control>
                <ng-container *ngIf="control.hasError('email')">{{ 'FORM_ERRORS.EMAIL_INVALID' | translate }}</ng-container>
              </ng-template>
            </nz-form-control>
          </nz-form-item>
        </div>
      </article>

      <div class="contact-persons-duplicate-error" *ngIf="contactPersons.hasError('duplicateContactPerson') && (contactPersons.dirty || contactPersons.touched)">
        {{ 'CONTACTS.CONTACT_PERSON_DUPLICATE' | translate }}
      </div>
    </section>
  </ng-container>

  <ng-container *ngIf="editingType === 'employee' && !lockRole">
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="role">{{ 'CONTACTS.ROLE' | translate }}<span class="required-asterisk-after" *ngIf="editingType === 'employee'">*</span></nz-form-label>
      <nz-form-control [nzSpan]="14" [nzValidateStatus]="contactForm.get('role')!" [nzErrorTip]="roleErrTpl">
        <nz-select formControlName="role" (ngModelChange)="onRoleChange($event)">
          <nz-option *ngFor="let option of roleOptions" [nzValue]="option.value" [nzLabel]="option.label"></nz-option>
        </nz-select>
        <ng-template #roleErrTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            {{ 'CONTACTS.ROLE_REQUIRED' | translate }}
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
  </ng-container>

  <ng-container *ngIf="editingType === 'service'">
    <nz-form-item>
      <nz-form-label [nzSpan]="6" nzFor="serviceTypes">{{ 'CONTACTS.SERVICE_TYPES' | translate }}<span class="required-asterisk-after" *ngIf="editingType === 'service'">*</span></nz-form-label>
      <nz-form-control [nzSpan]="14" [nzValidateStatus]="contactForm.get('serviceTypes')!" [nzErrorTip]="serviceTypesErrTpl">
        <nz-select
          formControlName="serviceTypes"
          nzMode="multiple"
          [nzDisabled]="lockServiceType"
          [nzNotFoundContent]="serviceTypeNotFoundTpl"
          [nzDropdownRender]="serviceTypeDropdownTpl"
        >
          <nz-option
            *ngFor="let option of serviceOptions"
            [nzValue]="option.value"
            [nzLabel]="option.label"
          ></nz-option>
        </nz-select>

        <ng-template #serviceTypeDropdownTpl let-menu>
          <ng-container [ngTemplateOutlet]="menu"></ng-container>
          <div *ngIf="showServiceTypeDropdownFooter && !lockServiceType" class="service-type-dropdown-footer">
            <div class="service-type-dropdown-footer__title">
              {{ 'CONTACTS.SERVICE_TYPE_FOOTER_TITLE' | translate }}
            </div>
            <div class="service-type-dropdown-footer__desc">
              {{ 'CONTACTS.SERVICE_TYPE_FOOTER_DESC' | translate }}
            </div>
            <button nz-button nzType="link" (click)="goToConfigureLandingPage()">
              {{ 'CONTACTS.SERVICE_TYPE_FOOTER_CTA' | translate }}
            </button>
          </div>
        </ng-template>

        <ng-template #serviceTypeNotFoundTpl>
          <div class="service-type-empty">
            <div class="service-type-empty__title">
              {{ 'CONTACTS.SERVICE_TYPE_EMPTY_TITLE' | translate }}
            </div>
            <div class="service-type-empty__desc">
              {{ 'CONTACTS.SERVICE_TYPE_EMPTY_DESC' | translate }}
            </div>

            <button nz-button nzType="link" (click)="goToConfigureLandingPage()">
              {{ 'CONTACTS.SERVICE_TYPE_EMPTY_CTA' | translate }}
            </button>
          </div>
        </ng-template>

        <ng-template #serviceTypesErrTpl let-control>
          <ng-container *ngIf="control.hasError('required')">
            {{ 'FORM_ERRORS.SERVICE_TYPE_REQUIRED' | translate }}
          </ng-container>
        </ng-template>
      </nz-form-control>
    </nz-form-item>
  </ng-container>

  <nz-form-item>
    <nz-form-control [nzSpan]="14" nzOffset="6">
      <button nz-button nzType="primary" (click)="save()">{{ 'CONTACTS.SAVE' | translate }}</button>
      <button nz-button (click)="cancel()">{{ 'CONTACTS.CANCEL' | translate }}</button>
    </nz-form-control>
  </nz-form-item>
</form>

<ng-template #addressFormatPopover>
  <div class="address-format-help">
    <p>{{ 'COMMON.ADDRESS_FORMAT_HELP_INTRO' | translate }}</p>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_NORMAL' | translate }}</strong>
      <code>Musterstraße 12, 12345 Musterort</code>
    </div>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_RANGE' | translate }}</strong>
      <code>Musterstraße 8 - 10, 12345 Musterort</code>
    </div>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_MULTI_HOUSE_NUMBERS' | translate }}</strong>
      <code>Muster Straße 12/14 + 16A, 12345 Musterort</code>
    </div>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_MULTI_STREET' | translate }}</strong>
      <code>Musterstraße 12 /  Musterweg 3, 12345 Musterort</code>
    </div>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_MULTI_ENTRIES' | translate }}</strong>
      <code>Musterstraße 12,  Musterweg 3, 12345 Musterort</code>
    </div>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_MULTI_ZIP' | translate }}</strong>
      <code>Muster Straße 63 /  Musterweg 9,  10010 Musterort   / 12345 Musterort</code>
    </div>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_SHARED_CITY' | translate }}</strong>
      <code>Muster Str. 18 /  Musterweg 1-3, 12333 / 12345 Musterort</code>
    </div>

    <div class="address-format-example">
      <strong>{{ 'COMMON.ADDRESS_FORMAT_SPECIAL_CHARS' | translate }}</strong>
      <code>Rue de Mustér 5, 12345 Musterort</code>
    </div>

    <p class="address-format-note">
      {{ 'COMMON.ADDRESS_FORMAT_HELP_NOTE' | translate }}
      <br />
      <em>{{ 'COMMON.ADDRESS_FORMAT_HELP_INVALID_EXAMPLE' | translate }}</em>
    </p>
  </div>
</ng-template>
